import { MatLegacyDialogConfig as MatDialogConfig } from "@angular/material/legacy-dialog";

export const dialogConfig: MatDialogConfig = {
  panelClass: "l-loading-dialog",
  maxWidth: 375,
  width: "100%",
  disableClose: true,
};
